class AnaphylaxisQuiz {
    constructor() {
        this.wrapper = document.querySelector('.digital-anaphylaxis-discussion-quiz-wrapper');
        if (!this.wrapper) return;
        this.quizWrapper = this.wrapper.querySelector('.quiz-wrapper');
        this.submitCardWrapper = this.wrapper.querySelector('.quiz-submit-card');
        this.signupForm = this.wrapper.querySelector('.quiz-submit-card form');
        this.startWrapper = this.wrapper.querySelector('.quiz-start-wrapper');
        this.consentCheckbox = this.wrapper.querySelector('.consent-checkbox-wrapper .custom-checkbox');
        this.currentQuestion = 0;
        this.answers = [];
        this.qaPairs = [];
        this.questions = [
            {
                id: 1,
                title: 'Gibt es seit dem letzten Arzttermin Veränderungen in deinem Gesundheitszustand?',
                description: 'Veränderungen seit dem letzten Termin',
                placeholder: 'z. B. Ich vermute, dass ich auf einen neuen Allergieauslöser reagiere.',
                type: 'comment'
            },
            {
                id: 2,
                title: 'Kam es seit dem letzten Arzttermin zu einer schweren allergischen Reaktion?',
                description: 'Veränderungen seit dem letzten Termin',
                placeholder: 'z. B. Ich hatte eine schwere allergische Reaktion nach dem Verzehr von Keksen.',
                type: 'comment'
            },
            {
                id: 3,
                title: 'Kennst du aktuell deine Allergieauslöser?',
                description: 'Wie es im Moment läuft',
                type: 'trigger'
            },
            {
                id: 4,
                title: 'Weißt du, wie du die relevanten Auslöser meiden kannst?',
                description: 'Wie es im Moment läuft',
                type: 'auto'
            },
            {
                id: 5,
                title: 'Weißt du, was im Falle einer schweren allergischen Reaktion zu tun ist?',
                description: 'Wie es im Moment läuft',
                type: 'auto'
            },
            {
                id: 6,
                title: 'Bereitet dir der Umgang mit einer möglichen schweren allergischen Reaktion Sorgen?',
                description: 'Wie es im Moment läuft',
                placeholder: 'Erzähle uns, was dir Sorgen bereitet.',
                type: 'comment'
            },
            {
                id: 7,
                title: 'Fühlst du dich sicher im Umgang mit den Notfallmedikamenten und weißt du, wann und wie sie anzuwenden sind?',
                description: 'Wie es im Moment läuft',
                type: 'auto'
            },
            {
                id: 8,
                title: 'Möchtest du mehr Informationen zu bestimmten Themen erhalten?',
                description: 'Wie es im Moment läuft',
                placeholder: 'z. B. Adrenalin im Notfall, Lagerungshinweise, Restaurantbesuche, Reisen',
                type: 'comment'
            },
            {
                id: 9,
                title: 'Hast du Fragen zu einer neuen oder bestehenden Allergie?',
                description: 'Wie es im Moment läuft',
                placeholder: 'z. B. Gibt es weitere Behandlungsmöglichkeiten?',
                type: 'comment'
            },
            {
                id: 'final_comment',
                title: 'Letzter Schritt: Ziele für den Arzttermin festlegen',
                description: 'Überlege, was dir im Alltag mit einer schweren Allergie am wichtigsten ist und wie dir deine Ärztin oder dein Arzt dabei helfen kann.',
                type: 'final-comment'
            }
        ];
        this.newsletterSignupWrapper = this.wrapper.querySelector('.quiz-submit-card .newsletter_signup_checkbox');
        this.newsletterSignupCheckbox = this.wrapper.querySelector('.quiz-submit-card .newsletter_signup_checkbox .custom-checkbox');
        this.knownUser = false;
        this.newsletterSignupVal = 'off';
        this.DADID_Cookie = null;
        this.newsletter_Cookie = null;
        this.DAD_email = null;
        this.init();
    }

    init() {
        this.startEvents();

        if (Utility.getCookie('DADID_Cookie') != '' && Utility.getCookie('DADID_Cookie') != null && Utility.getCookie('DADID_Cookie') != 'DADID_Cookie') {
            this.DADID_Cookie = Utility.getCookie('DADID_Cookie');
        } else {
            this.DADID_Cookie = localStorage.getItem('DADID_Cookie');
        }

        this.newsletter_Cookie = localStorage.getItem('newsletter_signup');

        if (this.DADID_Cookie != null && this.newsletter_Cookie === 'on') {
            this.knownUser = true;
            this.newsletterSignupWrapper.classList.add('d-none');
        } else {
            this.knownUser = false;
        }
    }

    startEvents() {
        this.wrapper.querySelector('.quiz-btn').addEventListener('click', (e) => {
            e.preventDefault();
            this.wrapper.classList.add('active');

            if (this.wrapper.querySelector('.quiz-heading').classList.contains('thanks-active')) {
                this.wrapper.querySelector('.quiz-heading').classList.remove('thanks-active');
                this.wrapper.querySelector('.quiz-heading').innerHTML = 'Leitfaden für Anaphylaxie-Gespräche'
            }

            this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.add('d-none');
            this.startWrapper.classList.remove('d-none');
        });

        this.wrapper.querySelector('.quiz-start-btn').addEventListener('click', () => {
            if (!this.consentCheckbox.checked) {

                const label = this.wrapper.querySelector('.quiz-input-label-wrapper');
                label.classList.add('required');
                if (window.innerWidth < 768) {
                    requestAnimationFrame(() => {
                        this.wrapper.querySelector('.quiz-input-label-wrapper').scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });
                }

                setTimeout(() => {
                    label.classList.remove('required');
                }, 2000);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dad_started_consent_no',
                    property:'adult'
                });

                return;
            }
            this.startQuiz();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'dad_started',
                property:'adult'
            });
        });

        this.wrapper.querySelector('.quiz-close-btn').addEventListener('click', () => {
            this.resetQuiz();
        });
    }

    startQuiz() {
        this.startWrapper.classList.add('d-none');
        this.wrapper.querySelector('.quiz-heading').classList.add('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.remove('d-none');
        this.quizWrapper.classList.remove('d-none');
        this.renderQuestion();
    }

    renderQuestion() {
        const question = this.questions[this.currentQuestion];
        if (!question) {
            this.renderSubmitScreen();
            return;
        }

        if (this.currentQuestion >= 2) {
            this.wrapper.classList.add('active-dark-bg');
        } else {
            this.wrapper.classList.remove('active-dark-bg');
        }

        const savedAnswer = this.answers.find(
            item => item.question_id === question.id
        );

        const isFinalComment = question.type === 'final-comment';

        this.quizWrapper.innerHTML = `
            <div class="quiz-question-card card-${question.id} ${isFinalComment ? 'final-comment-card' : ''}">
                ${!isFinalComment ? `
        
                    <div class="question-number">
                        ${question.id}
                    </div>
                    
                    <div class="question-description-text">
                        ${question.description}
                    </div>
                    
                    ${this.renderPagination()}
                    
                ` : ''}
                
                ${isFinalComment ? `
                    <div class="last-question-text">
                        Nur noch 1 Frage!
                    </div>
                ` : ''}

                <h3 class="question-title">
                    ${question.title}
                </h3>
                
                ${isFinalComment ? `
                    <div class="final-description">
                        ${question.description}
                    </div>
                ` : ''}

                ${this.renderQuestionContent(question)}

                <div class="quiz-navigation">
                    ${this.currentQuestion > 0 ? `
                        <button class="quiz-back-btn">
                          <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.6811 0.75L0.75 15.8573L15.6811 30.9699" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M33.75 15.75H0.75" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                          Zurück
                        </button>
                    ` : ''}
                </div>
            </div>
        `;

        this.bindQuestionEvents(question);

        this.restoreAnswer(question, savedAnswer);

        requestAnimationFrame(() => {
            this.wrapper.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }

    renderPagination() {
        return `
            <div class="pagination">
                ${this.questions
            .filter(item => item.id !== 'final_comment')
            .map((_, index) => `
                        <div class="step ${index === this.currentQuestion ? 'active' : ''}"></div>
                    `).join('')}
            </div>
        `;
    }

    renderQuestionContent(question) {
        switch (question.type) {

            case 'comment':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn" data-answer="YES">
                            Ja
                        </button>
                        <button class="quiz-answer-btn" data-answer="NO">
                            Nein
                        </button>
                    </div>

                    <div class="quiz-comment-wrapper d-none">
                        <div class="quiz-comment-field position-relative">
                            <textarea class="quiz-comment-input" placeholder="${question.placeholder}" maxlength="200"></textarea>
                            <div class="quiz-comment-count">0/200</div>
                        </div>
                    </div>
                    
                    <button class="quiz-next-btn d-none">
                        Weiter
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button> 
                `;

            case 'trigger':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn" data-answer="YES">
                            Ja
                        </button>

                        <button class="quiz-answer-btn" data-answer="NO">
                            Nein
                        </button>
                    </div>

                    <div class="quiz-trigger-wrapper d-none">
                        <label>
                            <input type="checkbox" value="Nahrungsmittel">
                            <span class="custom-checkbox"></span>
                            Nahrungsmittel
                        </label>

                        <label>
                            <input type="checkbox" value="Insektengifte">
                            <span class="custom-checkbox"></span>
                            Insektengifte
                        </label>

                        <label>
                            <input type="checkbox" value="Medikamente">
                            <span class="custom-checkbox"></span>
                            Medikamente
                        </label>
                        
                         <label>
                            <input type="checkbox" value="Latex">
                            <span class="custom-checkbox"></span>
                            Latex
                        </label>
                        
                         <label>
                            <input type="checkbox" value="Andere">
                            <span class="custom-checkbox"></span>
                            Andere
                        </label>
                    </div>
                    
                    <button class="quiz-trigger-next-btn d-none">
                        Weiter
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button>
                `;

            case 'auto':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn auto-btn" data-answer="YES">
                            Ja
                        </button>

                        <button class="quiz-answer-btn auto-btn" data-answer="NO">
                            Nein
                        </button>
                    </div>
                    
                    <button class="quiz-next-btn d-none">
                        Weiter
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button>
                `;

            case 'final-comment':
                return `
                    <div class="quiz-comment-wrapper">
                        <div class="quiz-comment-field position-relative">
                            <textarea class="quiz-comment-input" placeholder="z. B. versteckte Allergene in Lebensmitteln, Ärztliches Reisezertifikat, Umgang mit dem Anaphylaxierisiko am Arbeitsplatz oder zuhause, Behandlungsmöglichkeiten, Notfallmedikamente und ihre Lagerung" maxlength="200"></textarea>
                            <div class="quiz-comment-count">0/200</div>
                        </div>
                        <button class="quiz-submit-final-btn">
                            Weiter
                            <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M0.75 15.75H33.75" stroke="#570E3B" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                `;

            default:
                return '';
        }
    }

    bindQuestionEvents(question) {
        const card = this.quizWrapper.querySelector('.quiz-question-card');

        const backBtn = card.querySelector('.quiz-back-btn');
        if (backBtn) {
            backBtn.addEventListener('click', () => {
                this.prevQuestion();
            });
        }

        card.addEventListener('click', (e) => {
            const target = e.target.closest('button');
            if (!target) return;

            const goToNextQuestion = (data, delay = 0) => {
                this.saveAnswer(data);
                setTimeout(() => {
                    this.nextQuestion();
                }, delay);
            };

            const setActiveButton = () => {
                card.querySelectorAll('.quiz-answer-btn').forEach(btn => {
                    btn.classList.remove('active');
                });

                target.classList.add('active');
            };

            if (question.type === 'comment') {

                if (target.dataset.answer) {
                    setActiveButton();
                    const answer = target.dataset.answer;

                    if (answer === 'YES') {
                        card.querySelector('.quiz-comment-wrapper')?.classList.remove('d-none');
                        card.querySelector('.quiz-next-btn')?.classList.remove('d-none');
                        requestAnimationFrame(() => {
                            card.querySelector('.quiz-comment-wrapper').scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        });
                    }

                    if (answer === 'NO') {
                        card.querySelector('.quiz-comment-wrapper')?.classList.add('d-none');
                        goToNextQuestion({
                            question_id: question.id,
                            question: question.title,
                            answer: 'NO',
                            comment: ''
                        }, 500);
                    }
                    return;
                }

                if (target.classList.contains('quiz-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;

                    const comment = card.querySelector('.quiz-comment-input')?.value || '';
                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                        comment
                    });

                    return;
                }
            }

            if (question.type === 'trigger') {

                if (target.dataset.answer) {
                    setActiveButton();
                    const answer = target.dataset.answer;

                    if (answer === 'YES') {
                        card.querySelector('.quiz-trigger-wrapper')?.classList.remove('d-none');
                        card.querySelector('.quiz-trigger-next-btn')?.classList.remove('d-none');
                        requestAnimationFrame(() => {
                            card.querySelector('.quiz-trigger-wrapper').scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        });
                    }

                    if (answer === 'NO') {
                        card.querySelector('.quiz-trigger-wrapper')?.classList.add('d-none');

                        goToNextQuestion({
                            question_id: question.id,
                            question: question.title,
                            answer: 'NO',
                            triggers: []
                        }, 500);
                    }
                    return;
                }

                if (target.classList.contains('quiz-trigger-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;

                    let triggers = [];

                    if (activeBtn.dataset.answer === 'YES') {
                        triggers = [
                            ...card.querySelectorAll('input:checked')
                        ].map(input => input.value);

                        if (triggers.length === 0) {
                            card.querySelector('.quiz-trigger-wrapper')?.classList.add('required');

                            setTimeout(() => {
                                card.querySelector('.quiz-trigger-wrapper')?.classList.remove('required');
                            }, 2000);
                            return;
                        }
                    }

                    this.saveAnswer({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                        triggers
                    });
                    this.nextQuestion();
                    return;
                }
            }

            if (question.type === 'auto') {
                const existingAnswer = this.answers.find(
                    item => item.question_id === question.id
                );

                if (target.dataset.answer) {
                    setActiveButton();
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;
                    const data = {
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                    };

                    if (existingAnswer) {
                        this.saveAnswer(data);
                        card.querySelector('.quiz-next-btn')?.classList.remove('d-none');
                        return;
                    }

                    goToNextQuestion(data, 500);
                    return;
                }

                if (target.classList.contains('quiz-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;
                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                    });
                    return;
                }
            }

            if (question.type === 'final-comment') {
                if (target.classList.contains('quiz-submit-final-btn')) {
                    const comment = card.querySelector('.quiz-comment-input')?.value || '';

                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        comment
                    });

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'dad_completed',
                        property:'adult'
                    });
                }
            }
        });

        const textarea = card.querySelector('.quiz-comment-input');
        const counter = card.querySelector('.quiz-comment-count');

        if (textarea && counter) {
            counter.innerText = `${textarea.value.length}/200`;
            textarea.addEventListener('input', () => {
                counter.innerText = `${textarea.value.length}/200`;
            });
        }
    }

    saveAnswer(data) {
        const existingIndex = this.answers.findIndex(
            item => item.question_id === data.question_id
        );

        if (existingIndex !== -1) {
            this.answers[existingIndex] = data;
        } else {
            this.answers.push(data);
        }
    }

    QuestionDataLayer () {
        const item = this.answers.find(
            data => data.question_id === this.currentQuestion
        );

        function formatAnswer(value) {
            if (!value) return "";

            const TranslationValue = String(value).toLowerCase();

            if (TranslationValue === "yes") return "Ja";
            if (TranslationValue === "no") return "Nein";

            return value;
        }

        if (!item) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'dad_question_answer',
            questionNumber: String(item.question_id),
            answerValue: item.comment || (item.triggers?.length ? item.triggers : null) || formatAnswer(item.answer),
            property:'adult'
        });
    }

    nextQuestion() {
        this.currentQuestion++;
        this.renderQuestion();
        this.QuestionDataLayer ();
    }

    prevQuestion() {
        if (this.currentQuestion === 0) return;
        this.QuestionDataLayer ();
        this.currentQuestion--;
        this.renderQuestion();
    }

    restoreAnswer(question, savedAnswer) {
        if (!savedAnswer) return;

        const card = this.quizWrapper.querySelector('.quiz-question-card');

        if (savedAnswer.answer) {
            const activeBtn = card.querySelector(
                `.quiz-answer-btn[data-answer="${savedAnswer.answer}"]`
            );
            if (activeBtn) {
                activeBtn.classList.add('active');
            }
        }

        if (question.type === 'comment') {
            const nextBtn = card.querySelector('.quiz-next-btn');
            if (savedAnswer.answer === 'YES') {
                card.querySelector('.quiz-comment-wrapper')?.classList.remove('d-none');
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }

            if (savedAnswer.answer === 'NO') {
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }

            const textarea = card.querySelector('.quiz-comment-input');
            if (textarea) {
                textarea.value = savedAnswer.comment || '';
            }
        }

        if (question.type === 'trigger') {
            const nextBtn = card.querySelector('.quiz-trigger-next-btn');
            if (savedAnswer.answer === 'YES') {
                card.querySelector('.quiz-trigger-wrapper')?.classList.remove('d-none');
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }

                if (savedAnswer.triggers?.length) {
                    savedAnswer.triggers.forEach(trigger => {
                        const checkbox = [
                            ...card.querySelectorAll('input[type="checkbox"]')
                        ].find(input => input.value === trigger);
                        if (checkbox) {
                            checkbox.checked = true;
                        }
                    });
                }
            }

            if (savedAnswer.answer === 'NO') {
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }
        }

        if (question.type === 'auto') {
            const nextBtn = card.querySelector('.quiz-next-btn');
            if (nextBtn) {
                nextBtn.classList.remove('d-none');
            }
        }

        if (question.type === 'final-comment') {
            const textarea = card.querySelector('.quiz-comment-input');
            if (textarea) {
                textarea.value = savedAnswer.comment || '';
            }
        }
    }

    renderSubmitScreen() {

        this.wrapper.classList.remove('active-dark-bg');
        this.submitCardWrapper.classList.remove('d-none');
        this.quizWrapper.classList.add('d-none');

        console.log(this.answers)

        const submitBtn = this.submitCardWrapper.querySelector('.quiz-submit-btn');

        submitBtn.onclick = async () => {

            const name = this.submitCardWrapper.querySelector('.quiz-name-input').value;
            const email = this.submitCardWrapper.querySelector('.quiz-email-input').value;

            if (!name || !email) {
                this.submitCardWrapper.classList.add('required');
                setTimeout(() => {
                    this.submitCardWrapper.classList.remove('required');
                }, 2000);
                return;
            }

            const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            const verifiedEmail = email.match(emailPattern);

            if (verifiedEmail) {
                this.renderThankYou();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dad_report_result_signup',
                    property:'adult'
                });

                let formData = new FormData(this.signupForm);
                formData.append(
                    'existing_external_id',
                    md5(email)
                )
                const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                    method: "POST",
                    body: formData,
                });
                const res = await response.json();
                if (response.status == 200) {
                    if (res.data.attributes[0].external_id != '') {
                        if (typeof braze !== 'undefined') {
                            //braze sdk is loaded and we can tun the changeUser function
                            braze.changeUser(this.responseText);
                        }
                        if (typeof appboy !== 'undefined') {
                            //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                            appboy.changeUser(this.responseText);
                        }
                        if (Utility.getCookie('BUID_Cookie') == '' || Utility.getCookie('BUID_Cookie') == undefined) {
                            Utility.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                        }
                        Utility.setCookie('DADID_Cookie', res.data.attributes[0].external_id);
                        Utility.setCookie('DAD_email', email);
                        this.DADID_Cookie = res.data.attributes[0].external_id;
                        this.DAD_email = email;


                        if (this.newsletterSignupCheckbox.checked) {
                            this.newsletterSignupVal = 'on';
                            localStorage.setItem('newsletter_signup', 'on');
                        } else {
                            this.newsletterSignupVal = 'off';
                            localStorage.setItem('newsletter_signup', 'off');
                        }

                        let bodyData = {
                            "response": this.answers,
                            "email": email,
                            "external_id": this.DADID_Cookie,
                            "language": this.signupForm.querySelector('input[name="language"]').value,
                        };
                        this.sendAnswer(bodyData);
                    }
                }
            }
        };
    }

    renderThankYou() {
        this.wrapper.classList.remove('active');
        this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.remove('d-none');
        this.wrapper.querySelector('.anaphylaxis-heading').classList.remove('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.add('d-none');
        this.startWrapper.classList.add('d-none');
        this.quizWrapper.classList.add('d-none');
        this.submitCardWrapper.classList.add('d-none');
        this.wrapper.classList.remove('active-dark-bg');
        this.wrapper.querySelector('.quiz-heading').classList.add('thanks-active');
        this.wrapper.querySelector('.quiz-heading').innerHTML = 'Vielen Dank!'
        this.wrapper.querySelector('.quiz-btn-description-wrapper .quiz-description').innerHTML = 'Dein Anaphylaxie-Gesprächsleitfaden ist schon auf dem Weg in dein Postfach. Wir hoffen, dass er dich im nächsten Arztgespräch unterstützt.'
        this.wrapper.querySelector('.quiz-btn-description-wrapper .quiz-btn .quiz-btn-text').innerHTML = 'VERSUCHEN SIE ES ERNEUT'
    }

    resetQuiz() {
        this.currentQuestion = 0;
        this.answers = [];
        this.qaPairs = [];
        this.wrapper.classList.remove('active');
        this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.remove('d-none');
        this.wrapper.querySelector('.anaphylaxis-heading').classList.remove('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.add('d-none');
        this.startWrapper.classList.add('d-none');
        this.quizWrapper.classList.add('d-none');
        this.submitCardWrapper.classList.add('d-none');
        this.wrapper.classList.remove('active-dark-bg');
        this.consentCheckbox.checked = false;
    }

    async sendAnswer(bodyData) {
        try {
            const response = await fetch(`https://alk-app.klarify.me/api/digital-anaphylaxis-discussion-test`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${window.alkAppToken}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
            });

            const res = await response.json();
            if (response.status == 200) {
                let dadResultId = res.dad_id;
                let externalId = this.DADID_Cookie;
                let externalEmail = this.DAD_email;

                const CurrDate = new Date();
                const polandTime = new Date(
                    CurrDate.toLocaleString("en-US", { timeZone: "Europe/Warsaw" })
                );
                const pad = (n) => n.toString().padStart(2, '0');
                const year = polandTime.getFullYear();
                const month = pad(polandTime.getMonth() + 1);
                const day = pad(polandTime.getDate());
                const hours = pad(polandTime.getHours());
                const minutes = pad(polandTime.getMinutes());
                const seconds = pad(polandTime.getSeconds());

                // Get Poland's UTC offset in minutes
                const offsetMinutes = -polandTime.getTimezoneOffset();
                const offsetSign = offsetMinutes >= 0 ? "+" : "-";
                const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
                const offsetMins = pad(Math.abs(offsetMinutes) % 60);

                // Format full date string
                const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`;

                const finalComment = this.answers.find(item => item.question_id === 'final_comment');
                if (finalComment) {
                    this.qaPairs.push({
                        question: 'Meine Ziele für den Arzttermin',
                        answer: finalComment.comment
                    });
                }

                this.answers.forEach(item => {
                    switch (item.question_id) {
                        case 1:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Gibt es seit dem letzten Arzttermin Veränderungen in deinem Gesundheitszustand?',
                                    answer: item.comment || 'Ja'
                                });
                            }
                            break;

                        case 2:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Kam es seit dem letzten Arzttermin zu einer schweren allergischen Reaktion?',
                                    answer: item.comment || 'Ja'
                                });
                            }
                            break;

                        case 3:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Allergieauslöser',
                                    answer: 'Die Ärztin oder den Arzt fragen, was relevante Allergieauslöser sind oder wie ich sie herausfinden kann.'
                                });
                            }
                            break;

                        case 4:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Allergieauslöser meiden',
                                    answer: 'Die Ärztin oder den Arzt fragen, wie ich meine Allergieauslöser meiden kann.'
                                });
                            }
                            break;

                        case 5:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Schwere allergische Reaktion – was ist zu tun?',
                                    answer: 'Die Ärztin oder den Arzt bitten, die einzelnen Schritte für den Notfall mit mir durchzugehen.'
                                });
                            }
                            break;

                        case 6:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Sorgen im Falle einer schweren allergischen Reaktion',
                                    answer: item.comment || 'Ja'
                                });
                            }
                            break;

                        case 7:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Anwendung der Notfallmedikamente',
                                    answer: 'Die Ärztin oder den Arzt fragen, wie und wann meine Notfallmedikamente anzuwenden sind.'
                                });
                            }
                            break;

                        case 8:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Weiterer Gesprächsbedarf',
                                    answer: item.comment || 'Ja'
                                });
                            }
                            break;

                        case 9:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Fragen zu einer neuen oder bestehenden Allergie',
                                    answer: item.comment || 'Ja'
                                });
                            }
                            break;
                    }
                });


                let callEvents = [
                    {
                        "external_id": externalId,
                        "email": externalEmail,
                        "name": "anaphylaxis_quiz_completed",
                        "time": formattedDate,
                        "properties": {
                            "quiz_id": "anaphylaxis_adult_discussion_guide",
                            "quiz_locale": this.signupForm.querySelector('input[name="language"]').value,
                            "quiz_source": "external_system",
                            "qa_count": this.qaPairs.length,
                            "qa_pairs": this.qaPairs,
                        }
                    }
                ];

                let bodyDataMap = {
                    "external_id": externalId,
                    "url_key": "dad_id",
                    "url_id": dadResultId,
                    "newsletter_signup": this.newsletterSignupVal,
                    "events": callEvents,
                };
                this.sendPDFtoBraze(bodyDataMap);

                console.log(bodyDataMap)

                this.resetQuiz();
            }

        } catch (e) {
            console.error('Filter API call failed', e);
        }
    }

    async sendPDFtoBraze(bodyDataMap) {
        try {
            const response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${window.datahubAPIKey}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyDataMap)
            })
            if (response.status === 200) {
                await response.json();
            }
        } catch (e) {
            console.error('Filter API call failed', e);
        }
    }
}

new AnaphylaxisQuiz();